import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Index";
import { faqJsonLd, pageHead, SITE_URL } from "@/lib/seo";
import { homeFaqItems } from "@/data/faq-home";
import { claraVideoJsonLd } from "@/data/video";

export const Route = createFileRoute("/")({
  head: () => {
    const head = pageHead({
      title: "Nutricionista brasileira na Austrália | Clara Camille",
      description:
        "Acompanhamento nutricional em português na Austrália. Consulta inicial gratuita. Plano alimentar adaptado à rotina real de imigrantes, com suporte e constância.",
      path: "/",
      ogTitle: "Clara Camille | Nutricionista Brasileira na Austrália",
      ogDescription: "Consulta inicial 100% gratuita. Plano alimentar personalizado para brasileiros na Austrália.",
      jsonLd: [faqJsonLd(homeFaqItems), claraVideoJsonLd(`${SITE_URL}/`)],
    });
    // A foto do hero é o maior elemento visível: pré-carregar melhora o LCP.
    return { ...head, links: [...head.links, { rel: "preload", as: "image", href: "/clara-portrait-final.png" }] };
  },
  component: Page,
});
